/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface ILayoutControllerScope extends angular.IScope {
        model: models.LayoutModel
    }

    export class LayoutController implements IController {

        timeoutService: angular.ITimeoutService;
        httpService: angular.IHttpService;
        windowService: angular.IWindowService;
        locationService: angular.ILocationService;
        rootScopeService: angular.IRootScopeService;
        authService: any;
        localStorageService: any;
        signalrService: services.ISignalrService;

        constructor(
            private scope: ILayoutControllerScope,
            rootScopeService: angular.IRootScopeService,
            locationService: angular.ILocationService,
            timeoutService: angular.ITimeoutService,
            httpService: angular.IHttpService,
            windowService: angular.IWindowService,
            documentService: angular.IDocumentService,
            private processTypeService: services.ProcessTypeService,
            menuItemService: services.MenuItemService,
            signalrService: services.ISignalrService,
            private emailService: services.EmailService,
            siteConfigurationService: services.SiteConfigurationService,
            private siteInitializationService: services.SiteInitializationService,
            private userService: services.UserService,
            private userAdministrationService: services.UserAdministrationService,
            authService: any,
            localStorageService: any,
            testService: services.TestService,
            $q: angular.IQService) {

            this.timeoutService = timeoutService;
            this.httpService = httpService;
            this.windowService = windowService;
            this.authService = authService;
            this.locationService = locationService;
            this.localStorageService = localStorageService;
            this.signalrService = signalrService;
            this.rootScopeService = rootScopeService;
            
            var model = new models.LayoutModel(
                scope,
                userAdministrationService,
                windowService,
                localStorageService,
                signalrService,
                httpService,
                rootScopeService,
                locationService,
                processTypeService,
                menuItemService,
                emailService,
                siteConfigurationService,
                siteInitializationService,
                userService,
                authService,
                testService,
                $q);
            this.scope.model = model;   
        }
    }
}

warsApp.registerController('LayoutController', ['$scope', '$rootScope', '$location', '$timeout', '$http', '$window', '$document', 'processTypeService', 'menuItemService', 'signalrService', 'emailService', 'siteConfigurationService', 'siteInitializationService', 'userService', 'userAdministrationService', 'authService', 'localStorageService', "testService", "$q"]);
